// Imports from node_modules, installed via 'yarn add ...'
import * as bootstrap from 'bootstrap'; // Bootstrap (~97Kb)

import 'waypoints/lib/noframework.waypoints.min.js'; // Waypoints (intersection observer utility) (~10Kb)
import Cookies from 'js-cookie'; // Cookies.js (~2Kb)

// import TomSelect from 'tom-select'; // TomSelect (~52Kb) - now dynamically imported via theme.js
// import AOS from 'aos'; // Animate on Scroll (~14Kb) - now dynamically imported via extensions/aos-init.js
// import PhotoSwipe from 'photoswipe'; // PhotoSwipe (~56Kb) - now dynamically imported via extensions/product-photoswipe.js
// import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper'; // now dynamically imported via elements/swiper-slider.js
// import Swiper from 'swiper'; - now dynamically imported via elements/swiper-slider.js
// import { Navigation, Pagination, Autoplay, Thumbs } from 'swiper/modules'; - now dynamically imported via elements/swiper-slider.js
// import Masonry from 'masonry-layout'; // Masonry (~8Kb)

// Swiper.use([Navigation, Pagination, Autoplay, Thumbs]); - now dynamically imported via elements/swiper-slider.js

// Export for others scripts to use by attaching to the window
window.bootstrap = bootstrap;
window.Cookies = Cookies;

// window.TomSelect = TomSelect; - now dynamically imported via theme.js
// window.Swiper = Swiper; - now dynamically imported via elements/swiper-slider.js
// window.PhotoSwipe = PhotoSwipe; - now dynamically imported via extensions/product-photoswipe.js

// window.Masonry = Masonry;

// Initialisation
// AOS.init({
//   once: true
// });